import { render } from "./LocateWarehouse.vue?vue&type=template&id=6a80c502"
import script from "./LocateWarehouse.vue?vue&type=script&lang=js"
export * from "./LocateWarehouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__